import { esusApi } from "@/services/api";

export type ResumeIndicatorM2Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorM2Data {
	totalAttendances: number = 0;
	totalSharedAttendances: number = 0;
	totalNonSharedAttendances: number = 0;
}

export async function getResumeIndicatorM2({ uf, ibgeCode, ...params }: ResumeIndicatorM2Params) {
	const response = await esusApi.get<ResumeIndicatorM2Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m2/resume`,
		params
	);
	return response.data || new ResumeIndicatorM2Data();
}
